import React, { useState } from 'react';
import { Plus, X, FileSpreadsheet, ClipboardList, DollarSign, RefreshCw } from 'lucide-react';

const QuickActions = ({ onAction }) => {
  const [isOpen, setIsOpen] = useState(false);

  const actions = [
    { id: 'refresh', icon: RefreshCw, label: 'Refresh Data', color: 'bg-green-500' },
    { id: 'pricelist', icon: DollarSign, label: 'Price List', color: 'bg-purple-500' },
    { id: 'orders', icon: ClipboardList, label: 'Orders', color: 'bg-orange-500' },
    { id: 'export', icon: FileSpreadsheet, label: 'Export Data', color: 'bg-blue-500' },
  ];

  const handleAction = (actionId) => {
    setIsOpen(false);
    if (onAction) {
      onAction(actionId);
    }
  };

  return (
    <div className="fixed bottom-20 right-4 z-40 hidden">
      {/* Hidden - Using bottom navigation instead */}
      <div className={`flex flex-col-reverse gap-2 mb-2 transition-all duration-300 ${isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}>
        {actions.map((action, index) => (
          <button
            key={action.id}
            onClick={() => handleAction(action.id)}
            className={`${action.color} text-white p-3 rounded-full shadow-lg flex items-center gap-2 transition-all duration-200 hover:scale-105 active:scale-95`}
            style={{ transitionDelay: `${index * 50}ms` }}
          >
            <action.icon className="w-5 h-5" />
            <span className="text-sm font-medium pr-1">{action.label}</span>
          </button>
        ))}
      </div>

      {/* Main FAB button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-14 h-14 rounded-full shadow-xl flex items-center justify-center transition-all duration-300 ${
          isOpen 
            ? 'bg-slate-700 rotate-45' 
            : 'bg-gradient-to-br from-blue-600 to-blue-700'
        }`}
      >
        {isOpen ? (
          <X className="w-6 h-6 text-white" />
        ) : (
          <Plus className="w-6 h-6 text-white" />
        )}
      </button>
    </div>
  );
};

export default QuickActions;
